export default __webpack_public_path__ + "static/search-tolerance-88b846fbfe27a50b6b359a6451411263.svg";